import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { JobLog } from '../models/job/job-log.model';

@Injectable({
  providedIn: 'root',
})
export class JobLogService extends RequestService<JobLog> {
  static PATH = '/om/job/log';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, JobLogService.PATH, globalService.debugUrl);
  }
}
